import React from "react";

const VisaSmallIcon = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Visa"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.2387 16H0.761973C0.340958 16 0 15.6492 0 15.2168V0.783232C0 0.3508 0.340958 0 0.761973 0H23.2387C23.6598 0 24 0.3508 24 0.783232V15.2168C24 15.6492 23.6598 16 23.2387 16Z"
        fill="#F6F6F9"
      />
      <g clipPath="url(#clip0_3693_1186)">
        <path
          d="M10.075 5.09143L7.98023 10.0892H6.61357L5.58274 6.10076C5.52016 5.8551 5.46574 5.7651 5.27541 5.6616C4.96466 5.49301 4.4515 5.33485 4 5.23668L4.03067 5.09143H6.23057C6.51099 5.09143 6.76307 5.2781 6.82674 5.60101L7.37115 8.493L8.71664 5.09135H10.075V5.09143ZM15.4298 8.45758C15.4353 7.13851 13.6058 7.06584 13.6184 6.47659C13.6223 6.29726 13.793 6.10659 14.1668 6.05793C14.352 6.03368 14.8624 6.01518 15.4414 6.28159L15.6684 5.22177C15.3574 5.10885 14.9571 5.00018 14.4591 5.00018C13.1812 5.00018 12.2819 5.67951 12.2743 6.65226C12.266 7.37175 12.9162 7.77325 13.406 8.01233C13.9099 8.25717 14.079 8.4145 14.0771 8.6335C14.0735 8.96875 13.6752 9.11675 13.303 9.12258C12.6531 9.13258 12.276 8.94675 11.9755 8.807L11.7411 9.90191C12.0432 10.0405 12.6008 10.1614 13.1789 10.1675C14.5371 10.1675 15.4256 9.49658 15.4298 8.45758ZM18.8043 10.0893H20L18.9563 5.09143H17.8526C17.6044 5.09143 17.3951 5.23593 17.3024 5.4581L15.3624 10.0892H16.7199L16.9894 9.34274H18.6482L18.8043 10.0892V10.0893ZM17.3617 8.3185L18.0422 6.44201L18.4338 8.3185H17.3617ZM11.9222 5.09143L10.8531 10.0892H9.5603L10.6298 5.09143H11.9222Z"
          fill="#1434CB"
        />
      </g>
      <defs>
        <clipPath id="clip0_3693_1186">
          <rect
            width="16"
            height="5.16731"
            fill="white"
            transform="translate(4 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VisaSmallIcon;
